import {TextField} from "@mui/material"

import {PaperBlue} from "../../../shared/component/box/PaperBlue"
import {FieldRow} from "../../../shared/component/input/FieldRow"
import {SxPropsMap} from "../../../shared/helper/HelperType"
import {DeployValues} from "../../../shared/helper/HelperUtils"
import {DeploymentCommandPreview} from "../../deployment/component/DeploymentCommandPreview"
import {DeployNode, DeployPreviewCredentials} from "../api/ClusterType"

const SX: SxPropsMap = {
    box: {
        display: "flex", flexDirection: "column", gap: 1,
        padding: "12px 8px 6px", border: 1, borderColor: "divider", borderRadius: 2,
    },
}

type Props = {
    node: DeployNode,
    cluster: string,
    dcs: string,
    showErrors: boolean,
    credentials: DeployPreviewCredentials,
    duplicate: boolean,
    onChange: (node: DeployNode) => void,
}

export function ClusterDeployNode(props: Props) {
    const {node, cluster, dcs, showErrors, duplicate, credentials, onChange} = props

    return (
        <PaperBlue sx={SX.box}>
            <FieldRow>
                <TextField
                    label={"Name"}
                    placeholder={"etcd-1"}
                    value={node.name}
                    error={duplicate || (showErrors && !node.name)}
                    helperText={duplicate && "another node already uses this name"}
                    onChange={(e) => onChange({...node, name: e.target.value})}
                />
                <TextField
                    label={"Host"}
                    placeholder={"10.0.0.1"}
                    value={node.host}
                    error={showErrors && !node.host}
                    onChange={(e) => onChange({...node, host: e.target.value.toLowerCase()})}
                />
            </FieldRow>
            <FieldRow>
                {renderPort("Keeper Port", node.keeperPort, (v) => onChange({...node, keeperPort: v}))}
                {renderPort("Database Port", node.dbPort, (v) => onChange({...node, dbPort: v}))}
                {renderPort("SSH Port", node.sshPort, (v) => onChange({...node, sshPort: v}))}
            </FieldRow>
            <DeploymentCommandPreview command={node.command} postScripts={node.postScripts} values={getValues()}/>
        </PaperBlue>
    )

    function renderPort(label: string, value: number | undefined, onPortChange: (value?: number) => void) {
        return (
            <TextField
                type={"number"}
                label={label}
                value={value ?? ""}
                error={showErrors && !value}
                onChange={(e) => onPortChange(Number(e.target.value) || undefined)}
            />
        )
    }

    function getValues(): DeployValues {
        return {
            cluster,
            dcs,
            name: node.name,
            host: node.host,
            sshPort: node.sshPort,
            keeperPort: node.keeperPort,
            dbPort: node.dbPort,
            keeperUser: credentials.keeper.user,
            keeperPass: credentials.keeper.pass,
            dbUser: credentials.database.user,
            dbPass: credentials.database.pass,
        }
    }
}
